// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 数据库类型枚举 枚举类
 * 数据库类型枚举
 */
export enum EnumDBType {
  /** MySQL : MySQL */
  MYSQL = 1,
  /** MSSQL : MSSQL */
  MSSQL = 2
}

/**
 * 数据库类型枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumDBTypeMD {
  private static items = [
    new EnumItemMD('MYSQL', 1, 'MySQL', 'MySQL'),
    new EnumItemMD('MSSQL', 2, 'MSSQL', 'MSSQL')
  ];

  static getItem(enumItem: EnumDBType) {
    return this.items.find(item => item.name === EnumDBType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
